import {
  MaximumFractionDigits,
  PrecisionFloat,
  getRoundedPrecision,
  getTargetAmount,
} from '@bts-web/utils-formatting';

export const valueFromFiatToAsset = (
  amount: string,
  currentPrice: PrecisionFloat,
  customPrecision?: number | null,
  // this disables the reintroduction of locale decimal separator (comma) for math operations, because it breaks the pure math, in case the result is used for further calculations
  willBeUsedForMathOperations?: boolean,
): NonNullable<PrecisionFloat> => {
  const decimalSeparator = amount.includes(',') ? ',' : '.';

  const parsedValue = getTargetAmount({
    targetType: 'ASSET',
    price: currentPrice,
    sourceAmount: {
      value: amount.replace(decimalSeparator, '.'),
      precision: MaximumFractionDigits.ASSET,
    },
  });

  if (!parsedValue) {
    return {
      value: '',
      precision: customPrecision ?? MaximumFractionDigits.ASSET,
    };
  }

  if (willBeUsedForMathOperations) {
    return {
      value: getRoundedPrecision({
        value: parsedValue?.value ?? '',
        precision: customPrecision ?? MaximumFractionDigits.ASSET,
      }),
      precision: parsedValue.precision,
    };
  }

  return {
    value: getRoundedPrecision({
      value: parsedValue?.value ?? '',
      precision: customPrecision ?? MaximumFractionDigits.ASSET,
    }).replace('.', decimalSeparator),
    precision: parsedValue.precision,
  };
};
